import { DEFAULT_FILL_OPACITY } from '../../../core/constants.js';
import { ShapeColor } from '../../../core/types/color-palette.js';
import { getOpacity } from '../../../core/utils/getOpacity.js';
import { SeriesMetadata } from '../../types/histogram.js';

/**
 * Given a key, color token and colored histogram series, the bar color will be returned.
 *
 * @param key - Color key
 * @param color - Color token
 * @param highlightedSeriesIds - The highlighted colored histogram series array
 * @returns The shape color
 */
export const getBarStyle = (
  seriesMetadata: SeriesMetadata,
  highlightedSeriesIds?: string[],
): ShapeColor => {
  if (!highlightedSeriesIds) {
    return {
      color: seriesMetadata.color.Default,
      opacity: DEFAULT_FILL_OPACITY,
    };
  }

  const isCurrentHighlighted = !!highlightedSeriesIds?.includes(
    seriesMetadata.id,
  );

  return {
    color: seriesMetadata.color.Default,
    opacity: getOpacity(isCurrentHighlighted),
  };
};
